import { EditPartnerAgreement } from "src/entities/partnerContracts/ui/components/agreements/EditPartnerAgreement";

export function PartnerAgreementPage() {
  return <EditPartnerAgreement />;
}
